import CreateSpotifyReportContainer from 'wb-spotify/app/routes/reports/create/container';
import useCreateSpotifyReport from 'wb-spotify/app/routes/reports/create/useCreateSpotifyReport';
import { AnimatePresence } from 'framer-motion';
import SpotifyReportsList from 'wb-spotify/app/routes/reports/list';
import 'wb-spotify/app/routes/reports/style.scss';
import useSpotifyReportUrlOverlay from 'wb-spotify/app/routes/reports/hooks/useSpotifyReportUrlOverlay';

const SpotifyReports = () => {
	const {
		filters,
	} = useCreateSpotifyReport();

	useSpotifyReportUrlOverlay();

	return (
		<AnimatePresence mode="wait">
			{
				Object.keys(filters).length > 0 ? <CreateSpotifyReportContainer
					key="report-mutator"
				/> : <SpotifyReportsList
					key="report-list"
				/>
			}
		</AnimatePresence>
	);
};

export default SpotifyReports;
